/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/KlondikeTemplate/KlondikeCardAnimator',[
        'lodash',
        'pixi',
        'util/dictionary',
        'Arkadium/GameEngine/Core/EngineManagers',
        'Arkadium/GameEngine/Scenes/Nodes/SpriteNode',
        'Arkadium/GameEngine/Tween/Tween',
        'SolitaireShared/CardLogic/CardOp',
        'CardUI/PileView',
        'CardUI/CardView',
        'CardUI/SupplyView'
    ],
    function (_, PIXI, Dictionary, EngineManagers, SpriteNode, Tween, CardOp, PileView, CardView, SupplyView) {
        var KlondikeCardAnimator = function (supplyView) {
            this.initKlondikeCardAnimator(supplyView);
        };

        KlondikeCardAnimator.AnimationEntry = function () {
            this.initAnimationEntry();
        };

        KlondikeCardAnimator.AnimationEntry.prototype.initAnimationEntry = function () {
            this.WorldPos = new PIXI.Point();
            this.WorldRot = 0;
            this.WorldScale = new PIXI.Point(1, 1);
            this.CardFlip = 0;
            this.Wait = 0;
            this.Speed = 0;
            this.ForceLayer = 0;
            this.ForceLayer2 = 0;
            this.SoundToPlayAtFinish = null;
        };


        //readonly Dictionary<SceneNode, List<AnimationEntry>> _animationList;

        //readonly Dictionary<SceneNode, Tween> _tweenCache;

        KlondikeCardAnimator.prototype.initKlondikeCardAnimator = function (supplyView) {
            this.SupplyView = supplyView;
            this._animationList = new Dictionary(SpriteNode, Array);
            this._tweenCache = {};

            this.WinAnimator = null;

            this.AnimationLength = .2;
            this.AnimationDelay = .1;
            this.CardDelay = .05;

            this.AnimLengthDraw = .7;
            this.CardDelayDraw = .1;

            this._animationDelayTimer = 0;

            this._isInAnimationSet = false;

            this._isInAnimationSet = false;
            this._animationDelayTimer = 0;

            this._dealCardNum = 0;
            this._isDeal = false;
            this._isUndoing = false;

            this._animatingAction = null;
            this._animationLock = {};

            this.OnShuffleFinished = null;

            this._isShuffling = false;
            this._showButterfly = false;

            this._nextAnimationDelay = 0;

            this._nextAnimationAction = null;

            this._tweensToFinish = 0;

        };


        KlondikeCardAnimator.prototype.BeginAnimationSet = function (numActionsToExpect) {
            this._isInAnimationSet = true;
            this._animationDelayTimer = 0;
            this._animationList = new Dictionary(SpriteNode, Array);
            this._dealCardNum = 0;
            this._isDeal = false;
        };


        KlondikeCardAnimator.prototype.EndAnimationSet = function () {
            this._isInAnimationSet = false;
        };


        KlondikeCardAnimator.prototype.BeginAnimation = function (action, isUndoing) {
            if (!this._isInAnimationSet) {
                this._animationDelayTimer = 0;
                this._animationList.Clear();
                this._dealCardNum = 0;
                this._isDeal = false;
            }


            this._animatingAction = action;
            this._isUndoing = isUndoing;
            // save the starting position for each card
            _.forEach(this.SupplyView.CardSupply.GetCardList(), function (card) {
                var cardView = this.SupplyView.GetCardView(card);
                if (!this._animationList.ContainsKey(cardView)) {
                    // create the animation list entry
                    var current = new KlondikeCardAnimator.AnimationEntry();
                    current.Wait = this._animationDelayTimer;
                    current.Speed = 0;

                    //cardView.SceneTransform.Decompose(out current.WorldScale, out current.WorldRot, out current.WorldPos);
                    current.WorldPos = cardView.parent.toGlobal(cardView.position);

                    this._animationList.Add(cardView, [current]);
                }
            }, this);
        };

        KlondikeCardAnimator.prototype.ContinueAnimation = function (action, opNum) {
            this.SupplyView.UpdatePileChildren(false);

            var animSpeed = this.AnimationLength;
            var animDelay = this.AnimationDelay;
            var cardDelaySpeed = this.CardDelay;

            if (!this.SupplyView.CardSupply.EnforceGameRules) {
                animSpeed = 0.2;
                animDelay = 0.06;
                cardDelaySpeed = 0;
            }
            var op = action.Ops[opNum];
            if (op.Opcode === CardOp.Op.Move) {
                var fromPile = op.GetPile(CardOp.eMoveParams.SourcePile);
                var toPile = op.GetPile(CardOp.eMoveParams.DestPile);
                var numCards = op.GetNumber(CardOp.eMoveParams.NumCards);

                if (fromPile.Type === "Stock") {
                    animSpeed = this.AnimLengthDraw;
                    cardDelaySpeed = this.CardDelayDraw;
                }

                if (this._isUndoing) {
                    // if undoing, swap the piles
                    var tmp = fromPile;
                    fromPile = toPile;
                    toPile = tmp;

                    if (toPile.Type === "Waste" && this.SupplyView.CardSupply.GetOption("Draw") === "3") {
                        var wastePileView = this.SupplyView.GetPileView(toPile);
                        wastePileView.FanLimit = Math.min(wastePileView.FanLimit + 1, 3);
                    }

                    // undo card speed control
                    cardDelaySpeed *= .25;
                    animDelay *= .25;
                    animSpeed *= .25;
                }

                var fromPileView = this.SupplyView.GetPileView(fromPile);
                var toPileView = this.SupplyView.GetPileView(toPile);

                var rev = false;
                if (numCards < 0) {
                    numCards = -numCards;
                    rev = true;
                }
                if (numCards > 24) {
                    cardDelaySpeed *= .1;
                    this._isDeal = true;
                    // setTimeout(function () {
                    //     EngineManagers.Sounds.PlaySound("Deal_Klondike");
                    // }, 600);
                } else if (numCards > 6) {
                    cardDelaySpeed *= .25;
                }

                if (fromPileView.CardFacing === PileView.Facing.Hidden ||
                    toPileView.CardFacing === PileView.Facing.Hidden) {
                    animSpeed = 0;
                    animDelay = 0;
                    cardDelaySpeed = 0;
                } else {
                    if (this._nextAnimationDelay > 0) {
                        this._animationDelayTimer += this._nextAnimationDelay;

                        this._nextAnimationDelay = 0;
                    }
                }

                for (var cardNum = 0; cardNum < numCards; cardNum++) {
                    var cardIdx = cardNum + 1;
                    if (rev)
                        cardIdx = numCards - cardNum;

                    var card = toPile.NthFromTop(cardIdx);
                    var cardView = this.SupplyView.GetCardView(card);

                    if (cardView instanceof CardView) {
                        cardView.Animating = true;
                    }

                    var next = new KlondikeCardAnimator.AnimationEntry();
                    next.Wait = this._animationDelayTimer;
                    next.Speed = animSpeed;


                    if (fromPile.Type !== 'FaceDown') {
                        toPileView.parent.setChildIndex(toPileView, toPileView.parent.children.length - 1);
                    }
                    //cardView.SceneTransform.Decompose(out next.WorldScale, out next.WorldRot, out next.WorldPos);

                    //Vector2 cardPos = cardView.GetCardPositionInPile(null, true);
                    var cardPos = cardView.GetCardPositionInPile(null, true);

                    //next.WorldPos = cardView.Parent.ToGlobal(new Vector3(cardPos.X, cardPos.Y, cardView.Z));
                    next.WorldPos = cardView.Parent.toGlobal(cardPos); // TODO z order?

                    // cardView.Parent.parent.bringPileAndCardToTop(cardView.Parent, cardView)
                    // this.SupplyView.bringPileAndCardToTop(toPileView, cardView);


                    next.CardFlip = toPileView.CardFacing === PileView.Facing.FaceDown ? 1 : 0;

                    if (fromPile.Type === "Stock" && toPile.Type === "Waste") {
                        next.ForceLayer2 = CardView.TopLayer + cardNum + 1;
                    } else {
                        if (this._isDeal && numCards < 52) {
                            next.ForceLayer = CardView.TopLayer + 1 + card.Supply.Count - this._dealCardNum;
                            next.ForceLayer2 = CardView.TopLayer + 1 + card.Supply.Count + this._dealCardNum;
                            this._dealCardNum++;
                        }
                        if (fromPileView.CardFacing === PileView.Facing.FaceDown &&
                            toPileView.CardFacing === PileView.Facing.FaceUp) {
                            // SAM OVER HERE OVER HERE!!!
                            // this.SupplyVZiew.bringPileAndCardToTop(toPileView, cardView);
                            next.SoundToPlayAtFinish = "flipCard";
                        }
                    }

                    // Foundation particle effect.
                    if (toPile.Type === "Foundation" && !this._isUndoing) {
                        var foundationGlow = new SpriteNode("foundation_effect.png");
                        foundationGlow.Position = toPileView.Position;
                        foundationGlow.TextureAlphaEnabled = true;
                        foundationGlow.InputEnabled = false;
                        foundationGlow.ScaleUniform = CardView.ScaleFactor;
                        foundationGlow.Alpha = 1;

                        this.SupplyView.AddChildAt(foundationGlow, 0);

                        var delay = 0.15;
                        var duration = 0.8;
                        var scaleUp = 1.5;


                        Tween.Start(foundationGlow)
                            .Wait(delay)
                            //.Then()
                            //.FadeTo(1, 0)
                            .Then()
                            .ScaleTo(new PIXI.Point(scaleUp * CardView.ScaleFactor, scaleUp * CardView.ScaleFactor), duration, TWEEN.Easing.Cubic.Out)
                            .And().FadeTo(0, duration, TWEEN.Easing.Cubic.Out)
                            .Then()
                            .Call(function (node) {
                                node.Parent.RemoveChild(node);
                            });

                    }

                    //console.log(next);
                    this._animationList.Get(cardView).push(next);

                    if (numCards > 1)
                        this._animationDelayTimer += cardDelaySpeed;
                }
            }

            this._animationDelayTimer += animDelay;
        };


        KlondikeCardAnimator.prototype.EndAnimation = function (action, callThisWhenFinished) {
            var _tweenCache = {};
            this._tweensToFinish = 0;

            // now, actually perform all the tweens that we set up earlier
            _.forEach(this._animationList.GetKeys(), function (node) {
                var tweenList = this._animationList.Get(node);
                if (tweenList.length < 2)
                    return; // no anim for this node
                this._tweensToFinish++;


                var tween;
                if (_tweenCache[node.Id.toString()]) {
                    tween = _tweenCache[node.Id.toString()].Then();
                } else {
                    var tweens = Tween.GetTweens(node);
                    if (tweens != null && tweens.length > 0)
                        tween = tweens[0].Then();
                    else
                        tween = Tween.Start(node);

                    // TODO event handler
                    tween.Completed = function (t, n) {
                        delete _tweenCache[n.Id.toString()];
                    };
                    _tweenCache[node.Id.toString()] = tween;
                }

                for (var i = 0; i < tweenList.length; i++) {
                    var tweenEntry = tweenList[i];

                    // First, take all of the world transform stuff and take it back to the node's local space.
                    //Vector3 pos = Vector3.TransformCoordinate(tweenEntry.WorldPos, node.Parent.InverseSceneTransform);
                    var pos = node.parent.toLocal(tweenEntry.WorldPos);
                    //Vector3 scale = Vector3.TransformNormal(tweenEntry.WorldScale, node.Parent.InverseSceneTransform);
                    var scale = new PIXI.Point(1 / node.scale.x, 1 / node.scale.y);


                    // Set the forced card layer before we start tweening.
                    if (tweenEntry.ForceLayer != null && node instanceof CardView) {
                        node.LayerWhileAnimating = tweenEntry.ForceLayer.Value;
                    }

                    if (node.parent.Pile.Type !== 'FaceDown') {
                        node.parent.parent.setChildIndex(node.parent, node.parent.parent.children.length - 1);
                    }

                    if (i === 0) {
                        node.SetPosition(pos);
                        node.SetScale(scale);
                    } else {
                        tween = tween
                            .Wait(tweenEntry.Wait)
                            .Then();

                        if (tweenEntry.Wait > 0 && this._nextAnimationAction != null) {
                            var callAnimation = this._nextAnimationAction;
                            tween = tween
                                .Call(callAnimation)
                                .And();

                            this._nextAnimationAction = null;
                        }
                        if (tweenEntry.ForceLayer2 != null && node instanceof CardView) {
                            tween = tween.Call(function (n) {
                                n.LayerWhileAnimating = tweenEntry.ForceLayer2.Value
                            }).And();
                        }
                        tween = tween
                            .MoveTo(pos, tweenEntry.Speed, TWEEN.Easing.Cubic.Out)
                            .And()
                            .ScaleTo(scale, tweenEntry.Speed, TWEEN.Easing.Cubic.Out);


                        if (node instanceof CardView) {
                            tween = tween.And().CustomTo(
                                node.SetCardFlipAngle.bind(node),
                                node.GetCardFlipAngle.bind(node),
                                tweenEntry.CardFlip,
                                tweenEntry.Speed,
                                TWEEN.Easing.Quintic.Out
                            );
                        }
                    }

                    tween = tween.Then();


                    // Unset the forced card layer once the tween finishes.
                    if ((tweenEntry.ForceLayer != null || tweenEntry.ForceLayer2 != null) && node instanceof CardView) {
                        tween = tween.Call(function (n) {
                            if (n instanceof CardView)
                                n.LayerWhileAnimating = null;
                        });
                    }


                    if (tweenEntry.SoundToPlayAtFinish != null) {
                        tween.Call(function () {
                            if (action && action.Ops && action.Ops.length && (action.Ops.length > 20)) return;
                            EngineManagers.Sounds.PlaySound(tweenEntry.SoundToPlayAtFinish)
                        }); // TODO fix var in closure
                    }
                }
                tween = tween.Call(function (n) {
                    this.StopAnimating(n);
                }.bind(this));
                tween.Call(function (n) {
                    this.EndAnimTrigger(callThisWhenFinished)
                }.bind(this));

            }, this);

            this._tweenCache = {};

            //lock (_animationLock)
            //{
            if (this._tweensToFinish <= 0) {
                callThisWhenFinished(action);
            }
            //}
            this._nextAnimationDelay = 0;
        };

        KlondikeCardAnimator.prototype.StopAnimating = function (node) {
            if (node instanceof CardView) {
                node.Animating = false;
            }
        };

        //public event ShuffleFinishedDelegate OnShuffleFinished;
        KlondikeCardAnimator.prototype.EndAnimTrigger = function (onComplete) {
            //lock (_animationLock)
            //{
            this._animationList.Clear();
            this._tweensToFinish--;
            if (this._tweensToFinish <= 0) {
                if (this._isShuffling) {
                    this._isShuffling = false;
                    // EngineManagers.Sounds.StopSound("Deal_Klondike");
                    if (this.OnShuffleFinished != null)
                        this.OnShuffleFinished();
                }
                if (onComplete != null) {
                    onComplete(this._animatingAction);
                }
            }
            //}
        };

        KlondikeCardAnimator.prototype.BeginShuffleAnimation = function () {
            if (this.WinAnimator != null)
                this.WinAnimator.EndAnimation();
            this._isShuffling = true;
        };

        KlondikeCardAnimator.prototype.IsShuffleAnimationRunning = function () {
            return this._isShuffling;
        };

        KlondikeCardAnimator.prototype.ShouldShowEndingPopup = function () {
            if (this.WinAnimator == null)
                return true;
            return this.WinAnimator.ShouldShowEndingPopup();
        };


        /// <summary>
        /// Instantiate and begin the win animation.
        /// </summary>
        KlondikeCardAnimator.prototype.TriggerWinAnimation = function (endAnimationCallback) {
            if (this.SupplyView.CardSupply.Authority.IsChallenge) {
                this.WinAnimator = null;
                if (endAnimationCallback != null)
                    endAnimationCallback();
            } else {
                if (this.SupplyView.CurrentLayout === SupplyView.LayoutState.VerticalView) {
                    if (endAnimationCallback != null)
                        endAnimationCallback();
                    return; // snapped, no win anim
                }

                this.WinAnimator = this.SupplyView.CreateGameEndAnimator();

                this._showButterfly = !this._showButterfly;

                this.WinAnimator.BeginAnimation(endAnimationCallback, null, null, false); // Currently this only supports win animations that trigger when animation is complete; not ones that trigger during the movement of the last card.
            }
        };


        KlondikeCardAnimator.prototype.DoesAnimationBlockInput = function (action) {
            return false; // nothing especially blocks input in this game
        };


        KlondikeCardAnimator.prototype.DelayNextAnimation = function (delaySeconds) {
            this._nextAnimationDelay = delaySeconds;
        };


        KlondikeCardAnimator.prototype.OnNextAnimationStart = function (action) {
            this._nextAnimationAction = action;
        };

        return KlondikeCardAnimator;
    });

